import React, { useEffect } from 'react';
import Footer from './common/home/Footer';
import TopBar from './common/home/TopBar';
import { List, ListItem, ListItemText, ListSubheader, Typography } from '@mui/material';
import { homeBackground } from './common/ColorCodes';
import { CONST_BUSINESS_NAME, CONST_BUSINESS_MAIL, CONST_SITE_LABEL } from './common/Helper';

export const RefundPolicy = () => {

  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | Refund Policy`
  }, [])

  return (
    <div style={{ backgroundColor: homeBackground }}>
      <TopBar />

      <div className='policy-container'>
        <Typography variant={'h5'}>Refund Policy for {CONST_SITE_LABEL}</Typography>

        <List>
          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">1. Refund Eligibility</ListSubheader>
            <ListItemText className='list-item-text'>
              1.1. {CONST_SITE_LABEL} ({CONST_BUSINESS_NAME}) offers refunds in accordance with the following conditions:
              <List className=''>
                <ListItem className='list-item'>
                  <ListItemText className='list-item-text'>
                    <span className='item-bold'>Subscription Plans:</span> Refunds are available within 7 days of the initial purchase date for annual
                    or monthly subscription plans.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    <span className='item-bold'>One-Time Services:</span> Refunds for one-time services, such as individual optimization reports,
                    are considered on a case-by-case basis.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">2. Refund Process</ListSubheader>
            <ListItemText className='list-item-text'>
              2.1. To request a refund, you must submit a refund request via <span className='item-bold'>{CONST_BUSINESS_MAIL}</span> within
              the specified refund period.
            </ListItemText>

            <ListItemText className='list-item-text'>
              2.2. Refund requests must include the following information:
              <List>
                <ListItem>
                  <ListItemText className='list-item-text'>
                    Your name
                  </ListItemText>
                </ListItem>
                <ListItem>
                  <ListItemText className='list-item-text'>
                    Email address associated with your {CONST_SITE_LABEL} account
                  </ListItemText>
                </ListItem>
                <ListItem>
                  <ListItemText className='list-item-text'>
                    Order/invoice number
                  </ListItemText>
                </ListItem>
                <ListItem>
                  <ListItemText className='list-item-text'>
                    Reason for the refund request
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>

            <ListItemText className='list-item-text'>
              2.3. Upon receiving your refund request, our team will review it and determine whether you are
              eligible for a refund based on our Refund Policy.
            </ListItemText>

            <ListItemText className='list-item-text'>
              2.4. If your refund request is approved, the refund will be issued to the original payment method
              within 3 days of approval.
            </ListItemText>

          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">3. Non-Refundable Items</ListSubheader>
            <ListItemText className='list-item-text'>
              3.1. The following items are non-refundable:
              <List className=''>
                <ListItem className='list-item'>
                  <ListItemText className='list-item-text'>
                    <span className='item-bold'>Usage Fees:</span> Fees incurred for actual usage of {CONST_SITE_LABEL} services, such as AWS
                    account optimization recommendations, are non-refundable.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item'>
                  <ListItemText className='list-item-text'>
                    <span className='item-bold'>Partial Usage:</span> Refunds are not available for partially used subscription periods or services.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">4. Disputes</ListSubheader>
            <ListItemText className='list-item-text'>
              4.1. If you disagree with a refund decision or encounter any issues with the refund process,
              please contact our customer support team at <span className='item-bold'>{CONST_BUSINESS_MAIL}</span> for assistance.
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">5. Modifications to the Refund Policy</ListSubheader>
            <ListItemText className='list-item-text'>
              5.1. {CONST_SITE_LABEL} reserves the right to modify or update this Refund Policy at any time
              without prior notice. Any changes will be effective immediately upon posting the revised Refund
              Policy on our website.
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">6. Contact Us</ListSubheader>
            <ListItemText className='list-item-text'>If you have any questions or concerns about our Refund Policy, please contact us at <span className='item-bold'>{CONST_BUSINESS_MAIL}</span></ListItemText>
          </ListItem>
        </List>
      </div>

      <Footer />
    </div>
  )
}
